import WallexService from './WallexService'
import { FundingCreatePayload, FundingUpdatePayload, FundingRetrieve } from '../domain/Funding'

export default class FundingService extends WallexService {
    public static create(payload: FundingCreatePayload): Promise<FundingRetrieve> {
        return this.instance()
            .post('funding', payload)
            .then((response) => {
                const body = response.data as {
                    result: FundingRetrieve
                }

                return body.result
            })
            .catch((e) => {
                throw e
            })
    }

    public static retrieve(fundingId: string): Promise<FundingRetrieve> {
        return this.instance()
            .get('funding/' + fundingId)
            .then((response) => {
                const body = response.data as {
                    result: FundingRetrieve
                }

                return body.result
            })
    }

    public static update(payload: FundingUpdatePayload): Promise<FundingRetrieve> {
        return this.instance()
            .patch('funding', payload)
            .then((response) => {
                const body = response.data as {
                    result: FundingRetrieve
                }

                return body.result
            })
    }
}
